import "../styles/project-board.css";
import {MdClose} from 'react-icons/md';
import {HiOutlinePlus} from 'react-icons/hi';

const ProjectBoard = () => {
	return (
		<div className="project-board">
			<h1><b>Project Board</b></h1>
			<div className='project-creation'>
				<div className='layers'>
					<h3>
						<img src='/layers.png'/>{" "}
						<b>Layers</b>
					</h3>
					<div className='layer-images'>
						<div className='layer-settings'>
							<div className='allow-none'>
								<p>Allow None</p>
								<div className='toggle'></div>
							</div>
							<p className='add-button'><HiOutlinePlus/></p>
						</div>
						<div className='image-list'>
							<div className='image'>
								<img src='/NFT12.png'/>
								<p>Rarity</p>
								<MdClose/>
							</div>
							<div className='image'>
								<img src='/NFT13.png'/>
								<p>Rarity</p>
								<MdClose/>
							</div>
							<div className='image'>
								<img src='/NFT14.png'/>
								<p>Rarity</p>
								<MdClose/>
							</div>
							<div className='image'>
								<img src='/NFT15.png'/>
								<p>Rarity</p>
								<MdClose/>
							</div>
						</div>
					</div>
					<div className='backgrounds'>
						<p>Backgrounds</p>
						<span>12</span>
					</div>
					<div className='add-layer'>
						<input type='text' placeholder='Add New Layer'/>
						<p className='add-button'><HiOutlinePlus/></p>
					</div>
				</div>
				<div className='preview'>
					<h3>
						<img src='/preview.png'/>{" "}
						<b>Preview</b>
						<span>Random Play</span>
					</h3>
					<div className='preview-images'>
						<img src='/NFT17.png'/>
						<img src='/NFT10.png'/>
						<img src='/NFT11.png'/>
						<img src='/NFT12.png'/>
						<img src='/NFT13.png'/>
						<img src='/NFT14.png'/>
						<img src='/NFT15.png'/>
					</div>
					<div className='get-started'>
						<a href='#'>GENERATE NOW</a>
					</div>
				</div>
				<div className='settings'>
					<h3>
						<img src='/settings.png'/>{" "}
						<b>Settings</b>
					</h3>
					<div className='input-field'>
						<label>Collection Name</label>
						<input type='text' placeholder='Add Name'/>
					</div>
					<div className='input-field'>
						<label>Description</label>
						<input type='text' placeholder='Description'/>
					</div>
					<div className='half-input-fields'>
						<label>Dimensions</label>
						<div className='half-input'>
							<p>W</p>
							<input type='text' placeholder='1080'/>
						</div>
						<div className='half-input'>
							<p>H</p>
							<input type='text' placeholder='800'/>
						</div>
					</div>
					<div className='input-field'>
						<label>Total Supply</label>
						<input type='text' placeholder='0.0'/>
					</div>
					<div className='rarity'>
						<p>Rarity</p>
						<div className='toggle'></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectBoard;
